import React from 'react'
import { Paragraph } from '@fs/zion-ui'

const TrainingDataItem = ({ result, searchQuery }) => {
  return (
    <div style={{ minWidth: 300 }}>
      <Paragraph size="xs">{`${searchQuery}|${result?.id}|0.8498|WEB_SERVICE`}</Paragraph>
    </div>
  )
}

export default TrainingDataItem
